"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.textStyle=exports.SubHeading1=exports.SubHeading=exports.ReceiptWrapper=exports.ReceiptByTransactionIdContainer=exports.PaymentMtehodsContainer=exports.PaymentHeadingContainer=exports.PaymentHeading=exports.MalformedContainer=exports.CreditText=exports.CardLimitText=exports.BannerCashContainer=exports.BackDropContainer=exports.Alert=void 0;const SubHeading=exports.SubHeading=_styledComponents.default.h2` font-style: normal;
font-weight: 600 !important;
font-size: 20px !important;
line-height: 24px !important;
/* identical to box height, or 120% */
font-feature-settings: "liga" off, "calt" off;
/* Common/Neutral/N800 BrownRegular */
margin: 24px 0px 12px 0px;
color: #2a2928;`,SubHeading1=exports.SubHeading1=_styledComponents.default.div` font-style: normal;
font-weight: 600;
font-size: 24px;
line-height: 30px;
margin: 24px 0;
color: #2a2928;`,BackDropContainer=exports.BackDropContainer=_styledComponents.default.div`
.backdrop{
    z-index: 5 !important;
  }`,textStyle=exports.textStyle=`
<style>body{margin:0;font-family:-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}code{font-family:source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace}

</style>`,CreditText=exports.CreditText=_styledComponents.default.div` 
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 24px;
color: #2a2928;
margin-top:24px`,Alert=exports.Alert=_styledComponents.default.span`
display: flex;
justify-content: start;
align-items: center;
padding: 12px 16px;
background: #FAF9F8;
border: 1px solid #8BD9B3;
box-shadow: 0px 4px 8px rgba(56, 51, 46, 0.16);
border-radius: 8px;
font-family: 'Nunito Sans';
font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 18px;`,PaymentMtehodsContainer=exports.PaymentMtehodsContainer=_styledComponents.default.div`
&.mobile{
    width: 336px;
} 
.secure{
    display:flex;
    justify-content:center;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 16px;
    color: #2A2928;
    margin-top: 20px;
}`,BannerCashContainer=exports.BannerCashContainer=_styledComponents.default.div`
max-width: 660px;
border-radius: 8px;
border: 1px solid #ddd9d5;
&.mobile{
    width: 336px;
}`,PaymentHeadingContainer=exports.PaymentHeadingContainer=_styledComponents.default.div`  width: 424px;
height: 24px;
margin: 16px 0;
/* identical to box height, or 120% */
display: flex;
align-items: center;
line-height: 24px;`,PaymentHeading=exports.PaymentHeading=_styledComponents.default.h1`font-style: normal;
font-weight: 300 !important;
font-size: 28px !important;
line-height: 34px !important;
/* identical to box height, or 120% */
font-feature-settings: "liga" off, "calt" off;
/* Common/Neutral/N800 BrownRegular */
color:  #000000;
margin-bottom:16px;
margin-top:unset`,CardLimitText=exports.CardLimitText=_styledComponents.default.div`  
font-weight: 400;
font-size: 16px;
line-height: 24px;
color: #535250;
margin-bottom: 16px;`,ReceiptByTransactionIdContainer=exports.ReceiptByTransactionIdContainer=_styledComponents.default.div`
    padding: 0px !important;
    margin: 2rem 0 0 0;
    display: flex;
    justify-content: left;
`,ReceiptWrapper=exports.ReceiptWrapper=_styledComponents.default.div`
    width: 375px;
`,MalformedContainer=exports.MalformedContainer=_styledComponents.default.div`
   
    text-align: center;
    padding: 2rem 0 0 2rem;
    
    .malformed {
        font-size: 20px;
        font-weight: 600;
    }

`;